import * as React from 'react'
import * as cn from 'classnames'
import * as st from './StickyBlock.module.scss'
import EPGButton, { EPGButtonProps } from './StickyBlock/EPGButton'
import { Filter, FilterProps } from './StickyBlock/Filter'

interface StickyBlockProps {
    epgButton?: EPGButtonProps
    requiresExtraPadding?: boolean
    isPhablet?: boolean
    filter?: FilterProps
}



export class StickyBlock extends React.PureComponent<StickyBlockProps> {
    constructor(props: StickyBlockProps) {
        super(props)
    }

    render() {
        const isSticky = !this.props.isPhablet
        const contentClasses = cn(st.StickyContent, { [st.isSticky]: isSticky })

        return <div className={cn(st.StickyWrapper, {
            [st.isSticky]: !this.props.isPhablet,
            [st.topPadded]: this.props.requiresExtraPadding //This is a massive hack to enable non-sibling stickiness with Bento sticky nav.
        })}>
            {this.props.epgButton &&
                <EPGButton
                    {...this.props.epgButton}
                    className={contentClasses} />
            }
            {this.props.filter && <Filter {...this.props.filter} className={contentClasses} isSticky={isSticky} />}
        </div>
    }
}